import { call } from 'redux-saga/effects';
import { uploadFileApi } from '../../api/apiLists/fileUploadApi';
import { uploadFile } from '../../api/apiLists/uploadFile';
import { callWithAuth } from '../sagaApiHelper';

export function* uploadFileToS3(file, companyId, operation, metadata = {}) {
  try {
    const inputData = {
      filesData: [
        {
          fileName: file.name,
          contentType: file.type,
          customerId: companyId,
          operation: operation,
          ...metadata,
        }
      ]
    };

    const uploadResponse = yield call(callWithAuth, uploadFileApi, inputData);

    if (uploadResponse?.status && uploadResponse?.data && uploadResponse.data.length > 0) {
      const uploadObj = uploadResponse.data[0];
      yield call(uploadFile, uploadObj.uploadURL, file, {});
      return uploadObj.Key;
    } else {
      throw new Error('Failed to get upload URL for file');
    }
  } catch (error) {
    throw new Error(error.message || 'Failed to upload file to S3');
  }
}
